import React from 'react';
import { Paper,Divider, Grid } from '@material-ui/core';
import { FilterComponent } from '../../../shared_elements';
import Skeleton from '@material-ui/lab/Skeleton';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { invTypeGraphFilterOps } from '../'
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/no-data-to-display')(Highcharts);
const InvoiceLesseeGraph = ({ invoicelesseeGraphData, skeletonLoader, filter, getResponseBack, callExternalFunction }) => {
    let filterOptions = Object.assign({}, invTypeGraphFilterOps);
    const options = {
        chart: {
            type: 'column',
            zoomType: 'xy',
            panning: true,
            panKey: 'shift'
        },
        title: {
            text: 'Based on Lessee by Status',
            align: 'left',
            style: {
                fontFamily: 'Conv_IBMPlexSans-Regular',
                fontSize:'16px'
            }
        },
        subtitle: {
            text: `${invoicelesseeGraphData.title ? invoicelesseeGraphData.title : ''}`,
            align: 'left',
        },
        xAxis: {
            categories: invoicelesseeGraphData && invoicelesseeGraphData.invoice_status_categories
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Number of Invoices'
            }
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            },
            series:{
                point: {
                    events: {
                      click: function() {
                        callExternalFunction(this.series.name, this.category, 'basedOnStatusLessee');
                      }
                    }
                },
            }
        },
        legend: {
            enabled: true
        },
        series: invoicelesseeGraphData && invoicelesseeGraphData.invoice_status_lessee,
        credits: false,
        exporting: {
            buttons: {
                contextButton: {
                  menuItems: ['downloadPNG', 'downloadPDF'],
                },
            }
         }
    }

    return (
        skeletonLoader ? <Skeleton variant="rect" height={440} width='100%' /> : 
        <Paper>
            <div style={{padding:'0 5px'}}>
                <FilterComponent 
                    filter={filter}
                    filterMenu={filterOptions}
                    getResponseBack={(applyFilter) => getResponseBack(applyFilter)}
                />
            </div>
            <Divider />
            <div>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
            </div>
        </Paper>
    )
}
export default InvoiceLesseeGraph
